<template>
  <div class="goKS">

    <img class="goKS-bg" src="https://mediakit.enabot.com/eboX/img/pc/pc_goKS_bg.png" alt="">
    <img @click="goKSUrl" class="goKS-button" src="https://mediakit.enabot.com/eboX/img/pc/pc_goKS_button.png" alt="">
  </div>
</template>
<script>

export default {

  methods: {
    goKSUrl(){
      window.location.href = 'https://www.kickstarter.com/projects/enabot/enabot-ebo-x-family-robot-your-smart-guardian?ref=946nno&utm_source=pmkt&utm_medium=pmkt&utm_campaign=Enabot+EBO+X'
    }
  },
}
</script>
<style lang="scss" scoped>
.goKS {
  max-width: 1198px;
  margin: 0 auto;
  position: relative;
  .goKS-bg{
    width: 100%;
    height: auto;
  }
  .goKS-button{
    position: absolute;
    left: 50%;
    bottom: 13.7%;
    width: 54.4%;
    transform: translateX(-50%);
    height: auto;
    cursor: pointer;
  }

}
</style>